module.exports = __webpack_public_path__ + "img/chatbots_botfather.1f2f6156.jpeg";